import * as types from './types';

const initialState = {
	personalizations: {},
	error: null
};

const personalizationsReducers = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case types.PERSONALIZATIONS_ENTITY_SUBSCRIBE_START:
		case types.PERSONALIZATIONS_ENTITY_UNSUBSCRIBE_START:
		case types.PERSONALIZATIONS_THEMATIC_SUBSCRIBE_START:
		case types.PERSONALIZATIONS_THEMATIC_UNSUBSCRIBE_START:
		case types.PERSONALIZATIONS_GET_ME_START:
			return { ...state, isLoading: true };
		case types.PERSONALIZATIONS_ENTITY_SUBSCRIBE_SUCCESS:
		case types.PERSONALIZATIONS_ENTITY_UNSUBSCRIBE_SUCCESS:
		case types.PERSONALIZATIONS_THEMATIC_SUBSCRIBE_SUCCESS:
		case types.PERSONALIZATIONS_THEMATIC_UNSUBSCRIBE_SUCCESS:
		case types.PERSONALIZATIONS_GET_ME_SUCCESS:
			return { ...state, isLoading: false, personalizations: payload };
		case types.PERSONALIZATIONS_ENTITY_SUBSCRIBE_ERROR:
		case types.PERSONALIZATIONS_ENTITY_UNSUBSCRIBE_ERROR:
		case types.PERSONALIZATIONS_THEMATIC_SUBSCRIBE_ERROR:
		case types.PERSONALIZATIONS_THEMATIC_UNSUBSCRIBE_ERROR:
		case types.PERSONALIZATIONS_GET_ME_ERROR:
			return { ...state, isLoading: false, error: payload.message };
		default:
			return state;
	}
};

export default personalizationsReducers;
